/*
 * Jira Ticket:
 * Created Date: Mon, 6th Apr 2020, 15:16:28 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getListSiteQuery = gql`
  query allSites(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: SiteFilter
  ) {
    items: allSites(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      name
      postCode
      project {
        id
        name
        organisation {
          id
          name
        }
      }
      statistics {
        numberOfTowers
      }
    }
    total: _allSitesMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
    }
  }
`;
